const e = {
  small: "m1",
  medium: "1",
  large: "2"
};
export {
  e as HeadingSizeMap
};
